import { ETextStyleVariant, Text } from '@outdoorsyco/bonfire';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import FullSaveButton from '@/components/route/listing/SaveButton/FullSaveButton';
import { ButtonShape, ButtonSize, ButtonVariants } from '@/components/switchback/Button/Button';
import ShareButton from '@/components/ui/ShareButton/ShareButton';
import { WishlistModalWrapper } from '@/components/wishlists/WishlistModal';
import { EListingSource } from '@/services/analytics/listings/types';
import { IListingData } from '@/services/types/search/rentals/id';

interface IProps {
  listingData?: IListingData;
  isFavorite?: boolean;
  handleShare: () => void;
}

const ListingGalleryHeader: React.FC<IProps> = ({ listingData, isFavorite, handleShare }) => {
  return (
    <div className="flex items-center w-full h-full">
      <div className="flex-1 text-center">
        <Text variant={ETextStyleVariant.LargeBold}>
          <FormattedMessage
            id="w5mwG8"
            defaultMessage="Photo tour"
            description="Listing > Photo gallery > Gallery header title"
          />
        </Text>
      </div>
      <div className="flex items-center -mr-2 shrink-0">
        <ShareButton
          onClick={handleShare}
          shape={ButtonShape.pill}
          size={ButtonSize.normal}
          variant={ButtonVariants.borderless}
        />
        {listingData && (
          <WishlistModalWrapper
            isFavorite={isFavorite}
            item={listingData}
            isListingPage
            wishlistingEventData={{ index: 0, eventSource: EListingSource.LISTING }}
            TriggerComponent={({ isFavorite: isWishlisted, toggleFavorite }) => (
              <FullSaveButton
                onClick={toggleFavorite}
                isActive={isWishlisted}
                shape={ButtonShape.pill}
                size={ButtonSize.normal}
                variant={ButtonVariants.borderless}
                className="!py-3 !px-4"
              />
            )}
          />
        )}
      </div>
    </div>
  );
};

export default ListingGalleryHeader;
